<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
          {{ $t('message.importPrestation') }}
          </h3>
        </div>
      </div>

      <div class="" :class="[ mobileView ? 'pt-3': 'card-body']">
        <b-form>
          <div class="" :class="[ mobileView ? '': 'container']">

            <b-row>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="etablissement-group"
                    :label="$t('message.nomEtablissement')"
                    label-for="etablissement"
                >
                  <select id="etablissement" v-model="$v.form.etablissement_id.$model"
                          @change="clearErrorField('etablissement_id')"
                          class="form-control is-invalid retirerBordure"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('categorie_id')" style="color:red">
                                    {{getErrorsField('categorie_id')}}
                                    </span>
                </b-form-group>
              </b-col>
              <b-col sm="8">
                <b-form-group
                    id="upload-group"
                    :label="$t('message.uploadFile')"
                    label-for="upload"
                >
                  <b-form-file multiple
                               type="file"
                               accept=".xlsx"
                               ref="file_input"
                               id="upload"
                               :state="$v.form.file.$dirty ? !$v.form.file.$error : null"
                               :placeholder="$t('message.maxFileSize')"
                  >
                    <template slot="file-name" slot-scope="{ names }">
                      <b-badge variant="dark">{{ names[0] }}</b-badge>
                      <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                        + {{ names.length - 1 }} More file
                      </b-badge>
                    </template>
                  </b-form-file>
                  <span style="color: #f5365c;font-size: 80%" v-if="errorshasField('file')">
                                        {{ getErrorsField('file') }}
                                    </span>

                  <span style="color: #f5365c; font-size: 80%" v-if="maxFileSize.length>0" >{{ maxFileSize }}</span>

                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                    id="u"
                    label="."
                    label-for="upload"
                >
                  <b-button @click="cleardocuments">{{ $t('message.emptyUpload') }}</b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>

            </b-row>
            <b-row class="justify-content-center" v-if="can">
              <b-button @click="onSubmit" variant="primary">
                {{ $t('message.add') }}
              </b-button>
            </b-row>
          </div>


        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import SlimSelect from "slim-select";
import {required} from "vuelidate/lib/validators";

export default {
  name: "ImportCsv",
  computed: {
    ...mapGetters(["errors","etablissementPrestation", 'hasAdminRole',"userInstitutions",
      'hasGestionnaireRole','hasPraticienRole', 'hasMedecinControleRole',"categoriePrestations","prestations",'isComptable','hasAssistante']),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
    },

    mInstitutions:function () {
      let iArray = [];

      _.forEach(this.userInstitutions, function (institution) {
        iArray.push({nom:institution.name, id:institution.id});

      })
      return iArray;
    }
  },

  data() {
    return {
      mobileView: true,
      categorieSelect:Object,
      maxFileSize:'',
      form: {
        etablissement_id:this.$route.query.etablissement!='' ? this.$route.query.etablissement:'',
        file: '',
      }
    }
  },

  methods:{
    cleardocuments() {
      this.$refs['file_input'].reset()
    },
    handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', { args : args });
    },


    onSubmit: function(evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      let files = this.$refs.file_input.selectedFile;
      let nomFichier = "";
      if (!_.isNull(files) && files.length >0) {
        _.forEach(files, function (file, key) {
          let taille = (((file.size) / 1024) / 1024).toFixed(4);
          if (taille > 5) {
            nomFichier += key == 0 ? '' : ',' + file.name + ": " + taille + " Mo";
          }
        });

        if (nomFichier.length > 0) {
          this.maxFileSize = this.$i18n.t('message.maxFileSize') + nomFichier;
        } else {
          this.maxFileSize = "";
        }
      }else{
        this.maxFileSize = this.$i18n.t('message.requiredField');
      }

      if (!this.$v.form.$invalid && this.maxFileSize.length ==0) {
        let formData = new FormData();

        formData.append('etablissement_id', ''+this.form.etablissement_id);
        // let self= this;
        if (!_.isNull(files)) {
          for (var i = 0; i < this.$refs.file_input.selectedFile.length; i++) {
            let file = this.$refs.file_input.selectedFile[i];
            formData.append('file', file);
          }
        }

        let successMessage = this.$i18n.t('message.prestationCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };


        this.$store.dispatch('createEtablissementPrestationCvs', {args: formData, errorMessages, successMessage})

      }

    },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },

    errorshasField(field){
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field){
      this.$store.dispatch('clearErrorField', { field });

      this.getErrorsField(field);
    },
  },
  created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
  mounted() {
    this.getUserInstitutions();

    new SlimSelect({
      select: '#etablissement',
      placeholder: 'Select etablissement',
      limit: 1
    });

  },

  validations() {
    return {
      form: {
        etablissement_id:{required},
        file:{},
      }
    }
  },
}
</script>

<style scoped>

</style>